import React from 'react';
import { WhatsappMessage } from '../../types/whatsapp';
import { ImageAttachment } from './attachments/ImageAttachment';
import { VideoAttachment } from './attachments/VideoAttachment';
import { AudioAttachment } from './attachments/AudioAttachment';
import { DocumentAttachment } from './attachments/DocumentAttachment';
import { StickerAttachment } from './attachments/StickerAttachment';
import { LocationAttachment } from './attachments/LocationAttachment';
import { FallbackAttachment } from './attachments/FallbackAttachment';
export { MessageReplyPreview } from './attachments/MessageReplyPreview';

type RenderMediaOptions = {
    onAudioTimeChange?: (time: string) => void;
    onAudioDurationReady?: (duration: string) => void;
    messages?: WhatsappMessage[];
    currentMessageId?: string;
    getMediaUrl?: (mediaId: string, type: string) => Promise<string>;
};

export const renderMediaContent = (message: WhatsappMessage, options?: RenderMediaOptions) => {
    const raw = message.content as any;
    let content: any = raw;
    let effectiveType = message.type;

    if (typeof raw === 'string' && raw.trim().startsWith('{')) {
        try {
            const parsed = JSON.parse(raw);
            content = parsed;
            const mime: string | undefined = (parsed?.mime_type || parsed?.mimeType);
            if (effectiveType === 'text' && parsed?.id && mime) {
                if (mime.startsWith('image')) effectiveType = 'image';
                else if (mime.startsWith('video')) effectiveType = 'video';
                else if (mime.startsWith('audio')) effectiveType = 'audio';
                else if (mime.startsWith('application')) effectiveType = 'document';
            }
        } catch {
            // leave as-is if parsing fails
        }
    }

    switch (effectiveType) {
        case 'text':
            return <div className="text-break" style={{ whiteSpace: 'pre-wrap' }}>{typeof content === 'string' ? content : content?.text || ''}</div>;
        case 'image':
            return (
                <ImageAttachment 
                    mediaId={content?.id} 
                    caption={content?.caption}
                    messages={options?.messages}
                    currentMessageId={options?.currentMessageId}
                    getMediaUrl={options?.getMediaUrl}
                />
            );
        case 'video':
            return (
                <VideoAttachment 
                    mediaId={content?.id} 
                    caption={content?.caption}
                    messages={options?.messages}
                    currentMessageId={options?.currentMessageId}
                    getMediaUrl={options?.getMediaUrl}
                />
            );
        case 'audio':
            return <AudioAttachment mediaId={content?.id} />;
        case 'document':
            return <DocumentAttachment mediaId={content?.id} filename={content?.filename} caption={content?.caption} mimeType={content?.mime_type} />;
        case 'sticker':
            return <StickerAttachment mediaId={content?.id} createdAt={message.createdAt} isSentByMe={message.direction === 'outbound'} />;
        case 'location':
            return <LocationAttachment latitude={content?.latitude} longitude={content?.longitude} name={content?.name} address={content?.address} />;
        case 'reaction':
            return <div className="text-muted">Reaccionó: {content?.emoji || (typeof content === 'string' ? content : '👍')}</div>;
        default:
            return <FallbackAttachment type={effectiveType} textContent={typeof content === 'string' ? content : content?.text} />;
    }
};
